import { get } from '../../actions/methods/get'
import { set } from '../../actions/methods/set'

/**
 * API sonuçlarını önbellekleme için yardımcı fonksiyon
 * @param {Function} fetchFn - Veri getirme fonksiyonu
 * @param {string} prefix - Cache anahtarı için önek
 * @param {Object} params - Cache anahtarının parametreleri
 * @param {Object} options - Cache seçenekleri
 * @returns {Promise<any>} Önbellekten veya API'den alınan veri
 */
export const cachedFetch = async (fetchFn, prefix, params, options = {}) => {
  const forceRefresh = options.forceRefresh === true

  // Önbellekten veri alma (forceRefresh değilse)
  if (!forceRefresh) {
    const cachedData = get(prefix, params)
    if (cachedData !== null) {
      return cachedData
    }
  }

  // API'den veri alma
  try {
    const data = await fetchFn()

    // Başarılı sonucu önbellekleme
    if (data) {
      set(prefix, params, data, {
        ttl: options.ttl, // Artık string formatı da destekleniyor: "5m", "1h", vs.
      })
    }

    return data
  } catch (error) {
    // Hata durumunda önbelleğe kaydetme
    throw error
  }
}